import { Box, Typography } from "@mui/joy";
import { ReactElement } from "react";
import { CallTheme } from "../entities/callDesign";

/**
 * The modern-call masthead: whose call is this. Org name set as a wordmark in
 * the accent (corrected for text-on-white), over a 2px accent rule — the one
 * place the org color appears as a surface on the whole page.
 *
 * Deliberately the name, not the logo: most org logos are drawn for the old
 * dark ground and vanish on white. The logo can become an opt-in once the
 * asset constraints are settled (matches the email side of the redesign).
 *
 * @returns {ReactElement} the masthead, or nothing on legacy calls
 */
export function CallMasthead({
  theme,
  companyName,
  kind,
  logoURL,
}: {
  theme: CallTheme;
  companyName?: string;
  /** The call type shown opposite the wordmark (e.g. the event status). */
  kind?: string;
  /** The org's masthead pick: one of its branding assets instead of the
   * wordmark. Absent → the name as type. */
  logoURL?: string;
}): ReactElement | null {
  if (!theme.modern || !companyName) return null;

  return (
    <Box
      sx={{
        width: "100%",
        borderBottom: `2px solid ${theme.accent}`,
        pb: 1,
        pt: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: logoURL ? "center" : "baseline",
        gap: 2,
      }}
    >
      {logoURL ? (
        <Box
          component="img"
          src={logoURL}
          alt={companyName}
          sx={{ maxHeight: 36, maxWidth: 300, display: "block" }}
        />
      ) : (
        <Typography
          sx={{
            color: theme.accentText,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: 13,
            textAlign: "left",
            fontFamily: theme.fontStack,
          }}
        >
          {companyName}
        </Typography>
      )}
      {kind ? (
        <Typography
          sx={{
            color: "#6b7280",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: 11,
            whiteSpace: "nowrap",
          }}
        >
          {kind}
        </Typography>
      ) : null}
    </Box>
  );
}
